module.exports = __webpack_public_path__ + "assets/img/2.0f6b269d.jpg";